import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActionMenuService } from './action-menu.service';
@Component({
  selector: 'topo-action',
  template: `
    <div
      class="dropdown-item"
      [ngClass]="itemDisplayClasses"
      [ngStyle]="{ 'background-color': highlighted ? 'var(--action-item--highlighted-background-color)' : '' }"
      (click)="menuClick($event)"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      [routerLink]="!!routerLink ? routerLink : null">
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        @if (icon) {
          <i
            class="icon mr-2"
            [ngClass]="icon"></i>
        }
        @if (image) {
          <img
            class="mr-1"
            [src]="image" />
        }
        <div>{{ label }}</div>
        @if (iconRight) {
          <i
            class="icon"
            style="margin-left: 1.8rem"
            [ngClass]="iconRight"></i>
        }
      </div>
      @if (_toggle) {
        <div
          fxLayout="row"
          fxLayoutAlign="end center">
          <topo-switch
            [checked]="selected"
            (click)="menuClickDelay($event, 300)"></topo-switch>
        </div>
      }
    </div>
  `,
  styles: [],
  standalone: false
})
export class ActionComponent {
  @Input() item: any;
  @Input() label: string;
  @Input() icon: string;
  @Input() iconRight: string;
  @Input() image: string;
  @Input() highlighted: boolean;
  @Input() routerLink: string | string[];

  _divider = false;
  @Input()
  public set divider(value) {
    this._divider = value;
    const filteredClasses = this.itemDisplayClasses.filter(c => c !== 'divider');
    this.itemDisplayClasses = !value ? filteredClasses : ['divider', ...filteredClasses];
  }
  _toggle = false;
  @Input()
  public set toggle(value) {
    this._toggle = value;
    const filteredClasses = this.itemDisplayClasses.filter(c => c !== 'toggle');
    this.itemDisplayClasses = !value ? filteredClasses : ['toggle', ...filteredClasses];
  }
  @Input() selected = false;
  _disabled: boolean;
  @Input() set disabled(value: boolean) {
    this._disabled = value;
    const filteredClasses = this.itemDisplayClasses.filter(c => c !== 'disabled');
    this.itemDisplayClasses = !value ? filteredClasses : ['disabled', ...filteredClasses];
  }
  @Output() actionClick = new EventEmitter<any>();
  itemDisplayClasses: string[] = [];

  constructor(private actionMenuService: ActionMenuService) {}

  ngOnDestroy(): void {
    this.actionClick.complete();
  }

  menuClick(event: any): boolean {
    event.stopPropagation();

    if (this._disabled || this._toggle) {
      return false;
    }

    this.actionClick.emit(this.item || this.actionMenuService.item);

    this.actionMenuService.actionMenu?.toggleMenu();

    return false;
  }

  menuClickDelay(event: MouseEvent, delay: number): void {
    if (this._disabled) {
      return;
    }
    if (delay) {
      setTimeout(() => this.actionClick.emit(this.item), delay);
      return;
    }

    this.actionClick.emit(this.item);
  }
}
